import React, { useMemo } from 'react';
import { IFabricationOrderOtherPiece } from '../../../../../store/ducks/fabrication-orders/types';
import { TitleContainer, TableContainer } from '../styles';
import { Table } from '@gerdau/hefesto-mais-web';
import { Title } from '@gerdau/hefesto';

interface IExtraItemsContentProps {
  extraItens: IFabricationOrderOtherPiece[];
}

interface IExtraItemsContentTableDataSource {
  key: number;
  pieceDescription: string;
  steelDescription: string;
  diameterSize: string;
  measureA: number | undefined;
  measureB: number | undefined;
  measureC: number | undefined;
  amount: number | undefined;
  weight: string | number | undefined;
}

const ExtraItemsContent: React.FC<IExtraItemsContentProps> = ({
  extraItens
}) => {
  const extraItemsDataSourceProject: IExtraItemsContentTableDataSource[] =
    useMemo(() => {
      return extraItens.map(
        (
          {
            diameterSize,
            pieceDescription,
            steelDescription,
            amount,
            measureA,
            measureB,
            measureC,
            weight
          },
          idx
        ) => ({
          key: idx,
          diameterSize,
          pieceDescription,
          steelDescription,
          amount,
          measureA,
          measureB,
          measureC,
          weight
        })
      );
    }, [extraItens]);

  const getColumns = () => {
    const columns = [
      {
        title: 'Tipo de peça',
        dataIndex: 'pieceDescription',
        render: (pieceDescription: string) => <>{pieceDescription || '-'}</>
      },
      {
        title: 'Tipo de aço',
        dataIndex: 'steelDescription',
        render: (steelDescription: string) => <>{steelDescription || '-'}</>
      },
      {
        title: 'Bitola',
        dataIndex: 'diameterSize',
        render: (diameterSize: number) => (
          <>{diameterSize ? `${diameterSize} mm` : '-'}</>
        )
      },
      {
        title: 'Medida a',
        dataIndex: 'measureA',
        render: (measureA: number) => <>{measureA ? `${measureA} cm` : '-'}</>
      },
      {
        title: 'Medida b',
        dataIndex: 'measureB',
        render: (measureB: number) => <>{measureB ? `${measureB} cm` : '-'}</>
      },
      {
        title: 'Medida C',
        dataIndex: 'measureC',
        render: (measureC: number) => <>{measureC ? `${measureC} cm` : '-'}</>
      },
      {
        title: 'Quantidade',
        dataIndex: 'amount',
        render: (amount: number) => (
          <>{amount ? `${amount} ${amount === 1 ? 'peça' : 'peças'}` : '-'}</>
        )
      },
      {
        title: 'Peso total',
        dataIndex: 'weight',
        render: (weight: number) => <>{weight ? `${weight} kg` : '-'}</>
      }
    ];

    return columns;
  };

  return (
    <>
      <TitleContainer>
        <Title level={2}>Itens extras</Title>
      </TitleContainer>
      <TableContainer>
        <Table
          columns={getColumns()}
          dataSource={extraItemsDataSourceProject}
        ></Table>
      </TableContainer>
    </>
  );
};

export default ExtraItemsContent;
